module.exports = __webpack_public_path__ + "img/Goal2.3ef16799.svg";